// extracted by mini-css-extract-plugin
module.exports =  {"fadeInContainer":"fadeInContainer_sfVhE7te","fadeIn":"fadeIn_H3aqbP05","title":"title_UCIQ5TZd","description":"description_IVctUtOC"};